import { CustomBackgroundColors, CustomBackgroundColorDropDownItems, getCustomBackgroundColorValue } from "./customBackgroundColors";
import { getColorPickerContainerClassName, getColorPickerItemClassName } from "roosterjs-react/lib-mjs/colorPicker/utils/getClassNamesForColorPicker";
import { renderColorPicker } from "roosterjs-react/lib-mjs/colorPicker/component/renderColorPicker";
import { setBackgroundColor } from "roosterjs-editor-api";
const Key = "buttonNameBackgroundColor";
export const backgroundColorButton = {
    key: Key,
    unlocalizedText: "Text highlight color",
    iconName: "Highlight",
    onClick: (editor, key)=>{
        // This check will always be true, add it here just to satisfy compiler
        if (key !== Key) {
            setBackgroundColor(editor, getCustomBackgroundColorValue(key));
        }
    },
    dropDownMenu: {
        items: CustomBackgroundColorDropDownItems,
        itemClassName: getColorPickerItemClassName(),
        allowLivePreview: true,
        itemRender: function(item, onClick) {
            return renderColorPicker(item, CustomBackgroundColors, onClick);
        },
        commandBarSubMenuProperties: {
            className: getColorPickerContainerClassName()
        }
    }
};
